import { ArrowUpRight } from "lucide-react";
import { useT } from "@/lib/i18n";

export const Footer = () => {
  const t = useT();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#08080A] border-t border-white/10 pt-20 pb-10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16 border-b border-white/10">
          <div className="md:col-span-5">
            <div className="font-display text-4xl md:text-5xl font-semibold tracking-tight text-white leading-[0.95]">
              {t("footer.tagline_1", "Qualität und Termin —")}
              <br />
              {t("footer.tagline_2", "seit Generationen Schweizer Galvanik.")}
            </div>
            <a
              href="#kontakt"
              data-testid="footer-cta"
              className="mt-8 inline-flex items-center gap-2 text-white text-sm font-semibold link-underline"
            >
              {t("nav.cta", "Offerte einholen")} <ArrowUpRight className="w-4 h-4" strokeWidth={1.5} />
            </a>
          </div>

          <div className="md:col-span-2 md:col-start-7">
            <div className="overline mb-4">{t("footer.navigation", "Navigation")}</div>
            <ul className="space-y-3 text-sm">
              {[
                [t("nav.ueber", "Über uns"), "ueber"],
                [t("nav.verfahren", "Verfahren"), "verfahren"],
                [t("sections.ablauf_overline", "Ablauf").replace(/^—\s*/, ""), "ablauf"],
                [t("nav.team", "Team"), "team"],
                [t("sections.zertifikate_overline", "Zertifikate").replace(/^—\s*/, ""), "zertifikate"],
                [t("nav.kontakt", "Kontakt"), "kontakt"],
              ].map(([l, h]) => (
                <li key={h}>
                  <a
                    href={`#${h}`}
                    className="text-zinc-400 hover:text-white transition-colors"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="overline mb-4">{t("nav.kontakt", "Kontakt")}</div>
            <ul className="space-y-3 text-sm text-zinc-400">
              <li>
                <a
                  href="mailto:sekretariat@f-kamm.ch"
                  className="hover:text-white transition-colors"
                >
                  sekretariat@f-kamm.ch
                </a>
              </li>
              <li>
                <a
                  href="tel:+41817231642"
                  className="hover:text-white transition-colors"
                >
                  +41 81 723 16 42
                </a>
              </li>
              <li>{t("footer.hours_1", "Mo–Do · 07–17 Uhr")}</li>
              <li>{t("footer.hours_2", "Fr · 07–16 Uhr")}</li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-4">{t("footer.location", "Standort")}</div>
            <p className="text-sm text-zinc-400 leading-relaxed">
              Fritz Kamm AG
              <br />
              Zeughausstrasse 12
              <br />
              CH-8887 Mels · {t("common.switzerland", "Schweiz")}
            </p>
            <div className="mt-5 inline-flex items-center gap-2 px-3 py-1.5 border border-white/15 text-[11px] uppercase tracking-[0.2em] text-zinc-300">
              <span className="w-1.5 h-1.5 rounded-full bg-white" />
              ISO 9001 · ISO 14001
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[12px] text-zinc-500">
          <div className="flex items-center gap-3">
            <div className="w-7 h-7 border border-white/20 flex items-center justify-center font-display text-[11px] tracking-tighter text-white">
              FK
            </div>
            <span>© {year} Fritz Kamm AG · {t("footer.rights", "Alle Rechte vorbehalten.")}</span>
          </div>
          <div className="flex items-center gap-6">
            <a href="/impressum" data-testid="footer-impressum" className="hover:text-white transition-colors">{t("footer.imprint", "Impressum")}</a>
            <a href="/agb" data-testid="footer-agb" className="hover:text-white transition-colors">{t("footer.agb", "AGB")}</a>
            <a href="/datenschutz" className="hover:text-white transition-colors">{t("footer.privacy", "Datenschutz")}</a>
          </div>
        </div>

        {/* Credit line — designer / builder */}
        <div
          data-testid="footer-credit"
          className="mt-6 pt-4 border-t border-white/5 text-center text-[11px] text-zinc-500 leading-relaxed max-w-3xl mx-auto"
        >
          © {year} Design &amp; Konzeption: <span className="text-zinc-300">Petra Osterode</span> · Femmes Marketing.
          Alle Rechte vorbehalten. Die Gestaltung, Texte, Bilder und Inhalte dieser Website sind urheberrechtlich geschützt.
          Eine Vervielfältigung, Übernahme oder Nutzung – auch auszugsweise – ist ohne vorherige schriftliche Zustimmung
          nicht gestattet und kann rechtlich verfolgt werden.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
